import { Avatar, Box, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { fontSizes } from "../../../theme/font-sizes";
import { darkColors } from "../../../theme/colors";
import { AvatarWrapper } from "../home/user-profile";
import TruncateText from "../TruncateText";
import englishTranslations from "../../../i18n/translations/en";

const RacerProfile = ({ racerInfo, isMediumScreen, racerId }) => {
  const [selectedRacer, setSelectedRacer] = useState([]); // Default to first racer
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Toggle dropdown
  const dropdownRef = useRef(null); // Ref for dropdown container

  useEffect(() => {
    setSelectedRacer(racerInfo[0]);
    racerId(racerInfo[0].identifier);
  }, [racerInfo]);

  const handleSelectRacer = (racer) => {
    setSelectedRacer(racer);
    racerId(racer.identifier);
    setIsDropdownOpen(false); // Close dropdown after selection
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <>
      <Typography
        textAlign="left"
        color="white"
        fontSize={fontSizes.heading3}
        fontWeight={700}
      >
        Racer
      </Typography>

      <Box
        display="flex"
        mt={2}
        justifyContent="space-between"
        border="1px solid"
        borderRadius="12px"
        borderColor={darkColors.borderGray}
        height={60}
        px={2}
        sx={{ background: darkColors.background, position: "relative" }}
        ref={dropdownRef} // Attach ref to the container
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box>
            <Typography
              sx={{
                color: "white",
                fontSize: isMediumScreen ? fontSizes.info : fontSizes.heading3,
                fontWeight: 600,
              }}
            >
              <TruncateText
                text={selectedRacer.username}
                maxChars={isMediumScreen ? 20 : 15}
              />
            </Typography>
          </Box>
        </Box>

        {/* Open Dropdown Menu on Click */}
        <Box display="flex" alignItems="center">
          <Typography
            fontSize={isMediumScreen ? fontSizes.body : fontSizes.heading3}
            fontWeight={700}
            color={darkColors.buttonTop}
            sx={{ cursor: "pointer" }}
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            {englishTranslations.select}
          </Typography>
        </Box>

        {/* Custom Dropdown */}
        {isDropdownOpen && (
          <Box
            sx={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              background: darkColors.background,
              border: "1px solid",
              borderColor: darkColors.borderGray,
              borderRadius: "8px",
              mt: 1,
              zIndex: 10,
            }}
          >
            {racerInfo.map((racer, index) => (
              <Box
                key={index}
                sx={{
                  padding: "8px 12px",
                  color: "white",
                  cursor: "pointer",
                  textAlign: "left",
                  "&:hover": { background: darkColors.buttonTop },
                }}
                onClick={() => handleSelectRacer(racer)}
              >
                {racer.username}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

export default RacerProfile;
